
// You can write more code here

/* START OF COMPILED CODE */

import EditorPlatformMarkerImage from "../../../EditorPlatformMarkerImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformMarkerPlat extends EditorPlatformMarkerImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 167.5, y ?? 30, texture || 'game-all', frame ?? "platform.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
